import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { isZapErrorObject } from "../utils";

import { zapMetadataAtomFamily_SUSPENDS } from "./zapAtomFamily_SUSPENDS";

export const isZapPublishedAtomFamily_SUSPENDS = atomFamily(
  (zapId: string | undefined) => {
    const isZapPublishedAsyncAtom = atom<Promise<boolean | null>>(
      async (get) => {
        if (!zapId) {
          return null; // Indicates the status cannot be determined
        }

        const zap = await get(zapMetadataAtomFamily_SUSPENDS(zapId));

        if (!zap || isZapErrorObject(zap)) {
          return null; // Indicates the status cannot be determined
        }

        if ("is_published" in zap) {
          return zap.is_published;
        } else {
          return null; // zsl template zaps don't have is_published prop, so published value cannot be determined
        }
      },
    );

    isZapPublishedAsyncAtom.debugLabel = `isZapPublishedAtomFamily_SUSPENDS(${zapId})`;
    return isZapPublishedAsyncAtom;
  },
);
